import {saveQuestionDataInCache, getAnswersDataFromCache} from 'helpers/cache/cacheManager'
import removePrefix from './remove_prefix'

const answer_prefix = 'Answer:'

function savePollQuestionData(submitData, session) {
	saveQuestionDataInCache(
		submitData.answers,
		session.presentation_uid,
		session.session_uid,
		session.join_token,
		session.pincode
	)
}

async function getPollAnswersData(questionData, session) {
	const newAnswers = questionData.options.map(option => option.key)

	const answersFromCache = await getAnswersDataFromCache(
		newAnswers,
		session.presentation_uid,
		session.session_uid,
		session.join_token,
		session.pincode
	)

	return answersFromCache
		.filter(answer => answer.value !== '0')
		.map(answer => removePrefix(answer_prefix, answer.key))
}

export {
	savePollQuestionData,
	getPollAnswersData,
}
